import { vnTemplate } from '@valnet/vnKnockoutJsTemplates/vnTemplate';
/**
 * App-owned copy of filterSingleGroupSelector so Tasks does not depend on
 * older valnet_jslib builds that lack setLabel / label observable.
 */
export class filterSingleGroupSelector_template extends vnTemplate {
    getTemplateHtml() {
        return `
            <div class="dropdown select-single lib-dropdown lp-dropdown-select" data-bind="attr: { id: 'multipleSelector_' + elementIdentifier()}">
                <button type="button" class="dropdown-toggle icon" data-bind="text: label"></button>
                <div class="dropdown-list">
                    <div class="w-multi-dropdown">
                        <div class="w-multi-dropdown-header">
                             <div class="multi-dropdown-header">
                                <div class="w-search icon i-search2">
                                    <input class="lp-select-search multi-dropdown-search input-text" type="text" placeholder="Search" data-bind="textInput: searchValue, event: { keyup: onSearchAction}">
                                </div>
                            </div>

                             <div class="multi-dropdown-header" data-bind="visible: groups().length > 1">
                                 <select data-bind="
                                    options: groups,
                                    optionsText: 'name',
                                    optionsValue: 'id',
                                    value: selectedGroup,
                                    event: { change: onChangeGroupAction }
                                "></select>
                             </div>

                        </div>

                        <div class="multi-dropdown-body">
                            <ul class="multi-dropdown-list" data-bind="attr: { id: 'multipleSelector_content_' + elementIdentifier()}">

                                <!-- ko foreach: options -->
                                <li class="multi-dropdown-item" data-bind="style: { display: (($parent.searchValue() != '' && $parent.searchMatches.indexOf(id) == -1) || ($parent.selectedGroup() !== 0 && $parent.groupMatches.indexOf(id) == -1)) ? 'none' : 'block' }">
                                    <div class="w-input">
                                        <input data-bind="value: id, checked: $parent.selectedOption, attr:{id: 'item_' + $parent.elementIdentifier() + '_' + id}, event: { change: $parent.onOptionChange}" type="radio">

                                        <label data-bind="attr:{for: 'item_' + $parent.elementIdentifier() + '_' + id}">
                                            <span class="ex-name" data-bind="text: name"></span>

                                            <!-- ko if: $data.group != undefined -->
                                                <span class="ex-group-name" data-bind="text: group.name"></span>
                                            <!-- /ko -->

                                        </label>

                                    </div>
                                </li>
                                <!-- /ko -->

                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            `;
    }
    getTemplateName() {
        // Unique id so we never collide with an older vendor template already in <head>.
        return 'lp-filterSingleGroupSelector-template';
    }
    buildViewModel() {
        const self = this;
        return {
            groups: ko.observableArray([{ id: 0, name: '-- all --' }]),
            selectedGroup: ko.observable(0),
            groupMatches: ko.observableArray([]),
            options: ko.observableArray([{ id: 0, name: 'all' }]),
            selectedOption: ko.observable(0),
            selectedOptionText: ko.observable('all'),
            label: ko.observable(''),
            elementIdentifier: ko.observable(this.idElement),
            searchMatches: ko.observableArray([]),
            searchValue: ko.observable(''),
            onSearchAction: function () { self.onSearchAction(); },
            onOptionChange: function (data) { self.onOptionChange(data); return true; },
            onChangeGroupAction: function () { self.onChangeGroupAction(); return true; },
        };
    }
    setOptions(options) {
        const temp = this.onOptionChange;
        this.onOptionChange = function () { };
        this.getTemplateViewModel().options(options);
        this.onOptionChange = temp;
    }
    setGroups(groups) {
        groups.unshift({ id: 0, name: '-- all --' });
        this.getTemplateViewModel().groups(groups);
    }
    setSelectedOption(selectedOption) {
        this.getTemplateViewModel().selectedOption(selectedOption);
    }
    setselectedOptionText(text) {
        this.getTemplateViewModel().selectedOptionText(text);
    }
    setLabel(label) {
        this.getTemplateViewModel().label(label || '');
    }
    onOptionChange(item) {
        this.getTemplateViewModel().selectedOptionText(item.name);
        this.applyFilter();
    }
    onChangeGroupAction() {
        const selectedGroup = this.getTemplateViewModel().selectedGroup();
        if (selectedGroup === 0) {
            this.getTemplateViewModel().groupMatches([]);
            return;
        }
        const matches = [];
        for (const item of this.getTemplateViewModel().options()) {
            if (item.group != undefined && item.group.id == selectedGroup) {
                matches.push(item.id);
            }
        }
        this.getTemplateViewModel().groupMatches(matches);
    }
    onSearchAction() {
        const searchValue = this.getTemplateViewModel().searchValue();
        if (searchValue == '') {
            this.getTemplateViewModel().searchMatches([]);
            return;
        }
        const matches = [];
        for (const item of this.getTemplateViewModel().options()) {
            if (item.name.search(new RegExp(searchValue, 'i')) != -1 && matches.indexOf(item.id) == -1) {
                matches.push(item.id);
            }
        }
        this.getTemplateViewModel().searchMatches(matches);
    }
    applyFilter() {
        this.caller.filterSingleGroupSelectorOnChange(this.idElement);
    }
}
